import React,{useEffect, useState, useRef, useCallback} from "react";
import styles from "./index.module.less";

const XtScroll = ({children, dataAry=[], className, height=50, minHeight}) => {
  const elRef = useRef();
  const [scrollTop, setScrollTop] = useState(0);
  const [winHeight, setWinHeight] = useState(1);
  const parse = ()=>{
    try {
      const htmlRect = (document.scrollingElement || document.documentElement).getBoundingClientRect();
      const elRect = elRef.current.getBoundingClientRect();
      if (elRect.top >= 0) {
        elRef.current.scrollTop = 0;
        setScrollTop(0);
        const wh = Math.max(htmlRect.height - elRect.top, 0);
        setWinHeight(elRect.height < wh && elRect.height != 0 ? elRect.height : wh);
      } else {
        setWinHeight(Math.min(elRect.height + elRect.top, htmlRect.height));
        elRef.current.scrollTop = Math.abs(elRect.top);
        setScrollTop(Math.abs(elRect.top));
      }
    } catch (e) {
      elRef.current.scrollTop = 0;
      setScrollTop(0);
      setWinHeight(elRef.current.offsetHeight);
    }
    
  }
  const onScroll = useCallback(()=>{
    parse();
  },[]);
  useEffect(()=>{
    parse();
    document.addEventListener("scroll", onScroll);
    window.addEventListener("resize", onScroll);
    return ()=>{
      document.removeEventListener("scroll", onScroll)
      window.removeEventListener("resize", onScroll);
    }
  },[]);
  const startIndex = ()=>{
    const index = Math.floor(scrollTop / height);
    return Math.max(index - 1, 0);
  }
  const count = ()=>{
    const count = Math.ceil((scrollTop - startIndex()*height + winHeight + height) / height);
    return Math.min(count, dataAry.length);
  }
  const contentHeight = dataAry.length * height;
  const containerHeight = minHeight
    ? `max(${contentHeight}px, ${minHeight})`
    : `${contentHeight}px`;
  return <div ref={elRef} className={`${styles["xt-scroll-div"]} ${className}`} style={{ height: containerHeight }}>
    {children.map((child,index)=>{
      const index2 = index - startIndex()
      if(index2 >= 0 && index2 < count())
        return child;
      return null;
    })}
  </div>;
}
export default XtScroll;